<tg-row class="summary-page-vehicle-details-section__header">
    <tg-col md="6" sm="12">
        <p class="p-lead-copy">Vehicle details</p>
    </tg-col>
    <tg-col md="6" sm="12" class="summary-page-vehicle-details-section__header--right">
        <a routerLink="../{{ stepIds.vehicleDetails }}" routerLinkActive="active" class="h-link-no-visited">
            {{summarySectionLinkText}} boat details
        </a>
    </tg-col>
</tg-row>
<tg-row>
    <tg-col md="6" sm="12" class="summary-page-vehicle-details-section__content">
        <span class="summary-page-vehicle-details-section__content-label">Make:</span>
        {{ make }}
    </tg-col>
    <tg-col md="6" sm="12" class="summary-page-vehicle-details-section__content">
        <span class="summary-page-vehicle-details-section__content-label">Model:</span>
        {{ model }}
    </tg-col>
</tg-row>
<tg-row>
    <tg-col md="6" sm="12" class="summary-page-vehicle-details-section__content">
        <span class="summary-page-vehicle-details-section__content-label">Year:</span>
        {{ year }}
    </tg-col>
    <tg-col md="6" sm="12" class="summary-page-vehicle-details-section__content">
        <span class="summary-page-vehicle-details-section__content-label">Fuel type:</span>
        {{ fuelType }}
    </tg-col>
</tg-row>
<tg-row>
    <tg-col md="6" sm="12" class="summary-page-vehicle-details-section__content">
        <span class="summary-page-vehicle-details-section__content-label">Hull type:</span>
        {{ hullType }}
    </tg-col>
    <tg-col md="6" sm="12" class="summary-page-vehicle-details-section__content">
        <span class="summary-page-vehicle-details-section__content-label">Length:</span>
        {{ length }}
    </tg-col>
</tg-row>
<tg-row>
    <tg-col md="6" sm="12" class="summary-page-vehicle-details-section__content">
        <span class="summary-page-vehicle-details-section__content-label">Engine make:</span>
        {{ engineMake }}
    </tg-col>
    <tg-col md="6" sm="12" class="summary-page-vehicle-details-section__content">
        <span class="summary-page-vehicle-details-section__content-label">Engine year:</span>
        {{ engineYear }}
    </tg-col>
</tg-row>
<tg-row>
    <tg-col md="6" sm="12" class="summary-page-vehicle-details-section__content">
        <span class="summary-page-vehicle-details-section__content-label">Engine size:</span>
        {{ engineSize }}
    </tg-col>
    <tg-col md="6" sm="12" class="summary-page-vehicle-details-section__content">
        <span class="summary-page-vehicle-details-section__content-label">Engine type:</span>
        {{ engineType }}
    </tg-col>
</tg-row>
<tg-row>
    <tg-col md="6" sm="12" class="summary-page-vehicle-details-section__content">
        <span class="summary-page-vehicle-details-section__content-label">Engine hours:</span>
        {{ engineHours }}
    </tg-col>
</tg-row>
<tg-row>
    <tg-col sm="12" class="summary-page-vehicle-details-section__content">
        <span class="summary-page-vehicle-details-section__content-label">Boat location:</span>
        {{ boatLocation }}
    </tg-col>
</tg-row>
<tg-row>
    <tg-col md="6" sm="12" class="summary-page-vehicle-details-section__content">
        <span class="summary-page-vehicle-details-section__content-label">Brand new boat:</span>
        {{ isBrandNewBoat }}
    </tg-col>
</tg-row>